export const initialState = {
  products: [],
  featuredProducts: [],
  category: [],
  wishlist: [],
  productDetail: {},
  selectedProduct: {},
  cart: [],
  brands: [],
  filters: {
    rating: 5,
    category: [],
    brand: [],
    price: null,
    trending: false,
    includeOutStock: false,
    arrangeType: "",
    reqPage: 1,
    searchText: "",
  },
  loader2: false,
  searchLoader: true,
  searchValue: "",
  searchedProducts: [],
  showBurger: false,
  showSearch: false,
  currentPage: 1,
  screenWidth: window.innerWidth,
  showPassword: false,
  showFilter: false,
  showSignUpPassword: false,
  showSearchedProducts: false,
  addressList: [],
  showAddressModal: false,
  selectedAddress: "2354drtgf4d-7555-49cb--4b09711yujd",
  editId: "",
  orderDetails: [],
};
